import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import {
  ProSidebar,
  Menu,
  MenuItem,
  SubMenu,
  SidebarHeader,
  SidebarContent,
} from "react-pro-sidebar";
import { getLunaWebsiteUrl } from "./utils";
import "../staticfiles/css/leftsidebar.css";
import "react-pro-sidebar/dist/css/styles.css";

export default class LeftSideBar extends Component {
  state = {
    backfillDisplay: "240.7px",
    tableauDisplay: "240.7px",
    airstreamDisplay: "240.7px",
    promotionDisplay: "240.7px",
    playgroundDisplay: "240.7px",
    isToggled: false,
  };

  handleBackfill = () => {
    if (this.state.backfillDisplay === "0") {
      this.setState({ backfillDisplay: "240.7px" });
    } else {
      this.setState({ backfillDisplay: "0" });
    }
  };

  handleTableau = () => {
    if (this.state.tableauDisplay === "240.7px") {
      this.setState({ tableauDisplay: "0" });
    } else {
      this.setState({ tableauDisplay: "240.7px" });
    }
  };

  handleAirstream = () => {
    if (this.state.airstreamDisplay === "240.7px") {
      this.setState({ airstreamDisplay: "0" });
    } else {
      this.setState({ airstreamDisplay: "240.7px" });
    }
  };

  handlePromotion = () => {
    if (this.state.promotionDisplay === "240.7px") {
      this.setState({ promotionDisplay: "0" });
    } else {
      this.setState({ promotionDisplay: "240.7px" });
    }
  };

  handlePlayground = () => {
    if (this.state.playgroundDisplay === "240.7px") {
      this.setState({ playgroundDisplay: "0" });
    } else {
      this.setState({ playgroundDisplay: "240.7px" });
    }
  };

  handleClose = () => {
    if (this.props.handleClose !== null) {
      this.props.handleClose();
    }
  };

  render() {
    return (
      <ProSidebar
        style={{ position: "fixed" }}
        collapsed={this.props.isCollapsed}
        breakPoint="md"
        toggled={false}
        onToggle={this.props.toggleMenu}
      >
        {this.props.isCollapsed ? (
          <i
            class="bi bi-list-ul collapse-btn-collapsed"
            onClick={this.props.collapseMenu}
          ></i>
        ) : (
          <SidebarHeader
            style={{
              height: 80,
              position: "relative",
              borderBottom: "none",
              marginBottom: "30px",
            }}
          >
            <NavLink
              to="/promotional-ensemable"
              className="logo text-center logo-light text-white"
            >
              <span className="logo-lg">
                <h1>RW APP</h1>
              </span>
            </NavLink>
            <i
              class="bi bi-list-ul collapse-btn"
              onClick={this.props.collapseMenu}
            ></i>
            <p style={{ position: "absolute", bottom: "-45px", left: "20px" }}>
              Navigation
            </p>
          </SidebarHeader>
        )}
        <SidebarContent>
          <Menu iconShape="square">
            <SubMenu
              title="Charts"
              defaultOpen={true}
              icon={<i className="uil-chart"></i>}
            >
              <MenuItem>
                <NavLink to="/promotional-ensemable">
                  Promotional Ensemble
                </NavLink>
              </MenuItem>
              <MenuItem>
                <NavLink to="/keyword-search">Keyword Search</NavLink>
              </MenuItem>
            </SubMenu>
          </Menu>
        </SidebarContent>
      </ProSidebar>
    );
  }
}
